import { Box, Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { CopyIcon } from 'Asset/icon';
import useCopyToClipboard from 'Hook/useCopyToClipboard';
import { TextMedium, TextRegular, TextSemiBold } from 'UiKit/typography';
import getProductImage from 'View/host-stock-promo/helper/getProductImage';

import styles from './styles.module.css';

const InfoStockDetail = ({ data }) => {
  const { t } = useTranslation('host-stock-promo');
  const { copyToClipboard } = useCopyToClipboard();

  const handleCopy = () => copyToClipboard(data?.sku, 'Nomor SKU');

  const stockImage = getProductImage(data?.imagePath);

  return (
    <Box className={styles['card-stock-detail__container']} data-testid="info-stock-detail">
      <Box className={styles['stock-image__box']}>
        <Image src={stockImage} width={'100%'} height={'100%'} className={styles['stock-image']} />
      </Box>
      <Box className={styles['stock-info__box']}>
        <TextSemiBold className={styles['product-name__text']}>{data?.name}</TextSemiBold>
        <Box className={styles['card-stock-detail__box--info']}>
          <Box className={styles['card-stock-detail__box--barcode']}>
            <TextRegular className={styles['label-sku__text']}>{t('stock_detail.barcode')}</TextRegular>
            <Box className={styles['value-sku__container']} onClick={handleCopy}>
              <TextMedium className={styles['value-sku__text']}>{data?.sku}</TextMedium>
              <CopyIcon color="var(--color-primary60)" size="12px" />
            </Box>
          </Box>
          <Box className={styles['card-stock-detail__box--brand']}>
            <TextRegular className={styles['label-brand__text']}>{t('stock_detail.brand')}</TextRegular>
            <TextMedium className={styles['value-brand__text']}>{data?.brand}</TextMedium>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default InfoStockDetail;
